var React = require('react');

function Mapblack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"evenodd","d":"M21.484 3.909L15.287 2.03h-.034c-.034 0-.052-.017-.086-.017h-.172c-.035 0-.052 0-.086.017h-.035L8.902 3.857l-5.99-1.826a.719.719 0 0 0-.62.103.744.744 0 0 0-.292.569v16.713c0 .31.207.585.5.672l6.195 1.878c.07.017.138.034.207.034a.863.863 0 0 0 .206-.034l5.99-1.81 5.99 1.81c.069.017.137.034.206.034a.7.7 0 0 0 .413-.138.744.744 0 0 0 .293-.568V4.58c0-.31-.207-.569-.516-.672zM8.196 20.363l-4.785-1.447V3.65l4.785 1.448v15.265zm6.196-1.464l-4.784 1.464V5.115l4.784-1.465V18.9zm6.197 1.464l-4.785-1.447V3.65l4.785 1.448v15.265z"}));
}

Mapblack.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Mapblack;

Mapblack.default = Mapblack;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/mapblack.svg
// module id = 1498
// module chunks = 0